<p>
  receipt-form works!
</p>
